import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store, { initializeStore } from '@/store'

import CustomPrototypes from '@/custom/classes/custom_prototypes.js'
import NetworkUtils from '@/custom/classes/network_utils.js'
import MyUtils from '@/custom/classes/my_utils.js'
import Caller from '@/custom/classes/caller.js'
import Form from '@/custom/classes/form.js'
import Settings from './custom/classes/settings'
import sanitizeHelper from './custom/classes/sanitize_helper'
import VueMoment from '@/plugins/moment-plugin.js'
import QuillPlugin from 'vue-quill/vue-quill.js'

Vue.use(VueMoment)
Vue.use(QuillPlugin)

Vue.config.productionTip = false
new CustomPrototypes().setPrototypes()
Vue.prototype.$utils = MyUtils
Vue.prototype.$sanitize = sanitizeHelper.sanitize
Vue.prototype.$form = Form
Vue.prototype.$caller = new Caller()
Vue.prototype.$network_utils = new NetworkUtils()
Vue.prototype.$settings = new Settings()

// Initialize favicon based on environment settings
function initializeFavicon () {
  const settings = new Settings()
  try {
    const favicon = settings.get({ path: 'favicon' })
    if (favicon) {
      // Remove existing favicon links
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]')
      existingFavicons.forEach(link => link.remove())

      // Create and add new favicon
      const link = document.createElement('link')
      link.rel = 'icon'
      link.href = favicon
      document.head.appendChild(link)
    }
  } catch (error) {
    // Silently fail if favicon setting is not available
    console.debug('No custom favicon configured for this environment')
  }
}

// Initialize favicon on app startup
initializeFavicon()

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    initializeStore()
  }
}).$mount('#app')
